export const CompanyKontoExtMax = 2;
export { KontoDefaultLen };
var KontoDefaultLen;
(function (KontoDefaultLen) {
    KontoDefaultLen[KontoDefaultLen["Category"] = 4] = "Category";
    KontoDefaultLen[KontoDefaultLen["Creditor"] = 5] = "Creditor";
})(KontoDefaultLen || (KontoDefaultLen = {}));
//# sourceMappingURL=InterfaceBase.js.map